import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { IIndividualTransactionResponse } from '../models/transactions.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Get an individual transaction
 * 
 * @param {string} transactionId the id of the transaction being queried
 * 
 * @returns {object} the api response
 */
export const getIndividualTransactions = async (transactionId?: string,): Promise<IIndividualTransactionResponse> => {
  try {
    apiRetry(awsApiInstance);
    
    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get(`/transaction/${transactionId}`, {
      params: {
        wpId: userId,
        taxId: transactionId,
        showErrors: 0
      }
    });

    if ( data.errorMessage) {
      const error = JSON.parse(data.errorMessage);
      handleRouteError(error, 'Error getting transaction data');
      throw new Error(data.errorMessage);
    }

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting transaction data');
    throw(error);
  } 
}